import styled, { css } from 'styled-components';

import { headerVars } from '~organisms/Header';

const textStyle = css(({ theme }) => ({
  '& span, & strong': {
    letterSpacing: '0',
    textTransform: 'uppercase',
    color: theme.header.primaryAccent.text,
    fontFamily: 'Arial',
  },
}));

export const Container = styled.div(() => textStyle, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  cursor: 'pointer',
  gap: '12rem',

  '& span': {
    fontSize: '16rem',
  },

  '& strong': {
    fontWeight: 'bold',
    fontSize: '20rem',
  },

  '&[data-is-open="true"]': {
    svg: {
      transform: 'rotate(180deg)',
    },
  },
});

export const DropdownContainer = styled.div({
  position: 'absolute',
  left: '0',
  right: '0',
  top: '100%',
  height: `calc(100vh - ${headerVars.headerHeight})`,
});

export const CloseContainer = styled.div(({ theme }) => ({
  position: 'sticky',
  bottom: '0',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  padding: '6rem',
  borderRadius: '10rem',
  maxWidth: '72rem',
  textAlign: 'center',
  cursor: 'pointer',
  color: theme.header.primaryAccent.text,
  fontWeight: '800',
}));

export const DropdownCard = styled.div(({ theme }) => ({
  backgroundColor: theme.palette.white,
  boxShadow: `0rem 300rem 30rem 12rem ${theme.palette.darkLiver}66`, // Create a backdrop effect using shadow
  display: 'grid',
  gridTemplateColumns: '7fr 3fr',
  minHeight: '50vh',
}));

export const DropdownImageContainer = styled.div({
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
});

export const DropdownInvoiceContainer = styled.div({
  padding: '20rem 16rem',
});

export const DropdownButtonContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
});

export const ErrorContainer = styled.div(({ theme }) => ({
  fontSize: '14rem',
  color: theme.palette.orangeRed,
  paddingTop: '3rem',
}));

export const NotificationContainer = styled.div`
  margin-bottom: 10rem;
`;
